import { useSaPlaceQuery } from '@sim-admin-frontends/data-access-admin-be';
import { PageHeader } from '@sim-admin-frontends/ui-shared';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';

import { PageWrapper } from '../../components/layout/PageLayout';
import PlaceFeaturesContainer from '../../components/placeFeatures/view/PlaceFeatures.container';

type Props = {
  id: string;
};

const WrappedB = styled.b`
  white-space: pre-wrap;
`;

const PlaceFeaturesPage: FC<RouteComponentProps<Props>> = ({ match }) => {
  const { t } = useTranslation();
  const id = match.params.id;
  const { data } = useSaPlaceQuery({ id });

  return (
    <PageWrapper>
      <PageHeader
        title={t('places.features.title')}
        caption={
          <Trans
            t={t}
            i18nKey={'places.features.description'}
            values={{ cityName: data?.place?.name || '' }}
            components={{ b: <WrappedB /> }}
          />
        }
        testId="PlacesFeatures#PageHeader"
      />
      <PlaceFeaturesContainer placeId={id} />
    </PageWrapper>
  );
};

export default PlaceFeaturesPage;
